import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import HighlandsRanchPlumber from "./pages/HighlandsRanchPlumber";
import LittletonPlumber from "./pages/LittletonPlumber";
import LakewoodPlumber from "./pages/LakewoodPlumber";
import LongmontPlumber from "./pages/LongmontPlumber";
import ThorntonPlumber from "./pages/ThorntonPlumber";
import DenverPlumber from "./pages/DenverPlumber";
import ArvadaPlumber from "./pages/ArvadaPlumber";
import CastleRockPlumber from "./pages/CastleRockPlumber";
import CentennialPlumber from "./pages/CentennialPlumber";
import ResidentialPlumbing from "./pages/ResidentialPlumbing";
import CommercialPlumbing from "./pages/CommercialPlumbing";
import SewerRepairReplacement from "./pages/SewerRepairReplacement";
import BathroomKitchenRemodel from "./pages/BathroomKitchenRemodel";
import CustomHomePlumbing from "./pages/CustomHomePlumbing";
import Reviews from "./pages/Reviews";
import Pricing from "./pages/Pricing";
import UpfrontPlumbingPricesDenver from "./pages/UpfrontPlumbingPricesDenver";
import WaterHeaterPricing from "./pages/WaterHeaterPricing";
import TanklessWaterHeaterPricing from "./pages/TanklessWaterHeaterPricing";
import GarbageDisposalPricing from "./pages/GarbageDisposalPricing";
import FaucetPricing from "./pages/FaucetPricing";
import SewerCleaningPricing from "./pages/SewerCleaningPricing";
import SewerSnakeAugerPricing from "./pages/SewerSnakeAugerPricing";
import HydroJettingPricing from "./pages/HydroJettingPricing";
import RootRemovalPricing from "./pages/RootRemovalPricing";
import CastIronDescalingPricing from "./pages/CastIronDescalingPricing";
import FlatRateRheemHeaterPricing from "./pages/FlatRateRheemHeaterPricing";
import DiagnosticServicesPricing from "./pages/DiagnosticServicesPricing";
import SewerReplacementSpotRepairPricing from "./pages/SewerReplacementSpotRepairPricing";
import MeetTheTeam from "./pages/MeetTheTeam";
import CodeeJessen from "./pages/CodeeJessen";
import MichelleJessen from "./pages/MichelleJessen";
import Zack from "./pages/Zack";
import JesseSellers from "./pages/JesseSellers";
import ThankYou from "./pages/ThankYou";
import BookingSuccess from "./pages/BookingSuccess";
import EmergencySuccess from "./pages/EmergencySuccess";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/highlands-ranch-plumber" element={<HighlandsRanchPlumber />} />
          <Route path="/littleton-plumber" element={<LittletonPlumber />} />
          <Route path="/lakewood-plumber" element={<LakewoodPlumber />} />
          <Route path="/longmont-plumber" element={<LongmontPlumber />} />
          <Route path="/thornton-plumber" element={<ThorntonPlumber />} />
          <Route path="/denver-plumber" element={<DenverPlumber />} />
          <Route path="/arvada-plumber" element={<ArvadaPlumber />} />
          <Route path="/castle-rock-plumber" element={<CastleRockPlumber />} />
          <Route path="/centennial-plumber" element={<CentennialPlumber />} />
          <Route path="/residential-plumbing" element={<ResidentialPlumbing />} />
          <Route path="/commercial-plumbing" element={<CommercialPlumbing />} />
          <Route path="/sewer-repair-replacement" element={<SewerRepairReplacement />} />
          <Route path="/bathroom-kitchen-remodel" element={<BathroomKitchenRemodel />} />
          <Route path="/custom-home-plumbing" element={<CustomHomePlumbing />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/pricing" element={<UpfrontPlumbingPricesDenver />} />
          <Route path="/upfront-plumbing-prices-denver" element={<UpfrontPlumbingPricesDenver />} />
          <Route path="/water-heater-pricing" element={<WaterHeaterPricing />} />
          <Route path="/flat-rate-affordable-rheem-water-heaters-in-colorado" element={<FlatRateRheemHeaterPricing />} />
          <Route path="/tankless-water-heater-pricing" element={<TanklessWaterHeaterPricing />} />
          <Route path="/garbage-disposal-pricing" element={<GarbageDisposalPricing />} />
          <Route path="/faucet-pricing" element={<FaucetPricing />} />
          <Route path="/sewer-cleaning-pricing" element={<SewerCleaningPricing />} />
          <Route path="/sewer-snake-auger-pricing" element={<SewerSnakeAugerPricing />} />
          <Route path="/hydro-jetting-pricing" element={<HydroJettingPricing />} />
          <Route path="/root-removal-pricing" element={<RootRemovalPricing />} />
          <Route path="/cast-iron-descaling-pricing" element={<CastIronDescalingPricing />} />
          <Route path="/diagnostic-services-pricing" element={<DiagnosticServicesPricing />} />
          <Route path="/sewer-replacement-spot-repair-pricing" element={<SewerReplacementSpotRepairPricing />} />
          <Route path="/meet-the-team" element={<MeetTheTeam />} />
          <Route path="/team/codee-jessen" element={<CodeeJessen />} />
          <Route path="/team/michelle-jessen" element={<MichelleJessen />} />
          <Route path="/team/zack" element={<Zack />} />
          <Route path="/team/jesse-sellers" element={<JesseSellers />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/booking-success" element={<BookingSuccess />} />
          <Route path="/emergency-success" element={<EmergencySuccess />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Analytics />
      <SpeedInsights />
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
